export default "__VITE_ASSET__DdGCd$5a__"